import { Series } from './series';
import { DicomPatient, DicomPatientStudy } from './dicomPatient';

export class PatientDataSet {
    public readonly patientModule: DicomPatient;

    public series: Array<Series> = [];

    public study?: DicomPatientStudy = {} as DicomPatientStudy;

    constructor(patient: DicomPatient) {
        this.patientModule = patient;
    }

    get PatientName(): string {
        return this.patientModule.patientName;
    }

    get PatientID(): string {
        return this.patientModule.patientId;
    }

    get PatientSex(): string | undefined {
        return this.patientModule.patientSex;
    }

    get PatientBirthDate(): string | undefined {
        return this.patientModule.patientBirthDate;
    }

    public removeSeries(seriesInstanceUID: string): boolean {
        const index = this.series.findIndex(
            (s) => s.seriesInstanceUID === seriesInstanceUID
        );
        if (index > -1) {
            this.series.splice(index, 1);
            return true;
        }
        return false;
    }
}
